import styled from 'styled-components';

const MainSectionStyle = styled.section`
	--itemsMargin: var(--sp4x);
	--imgMarginB: var(--sp7x);
	--industriesGap: var(--sp2x);
	--borderRadius: var(--sp4x);
	--imageSize: 56.7%;

	margin-top: var(--pageDistance);

	.date-wrapper {
		display: flex;
		align-items: center;
		margin-bottom: var(--itemsMargin);

		.dot {
			width: var(--sp0-5x);
			height: var(--sp0-5x);
			background-color: var(--red1000);
			border-radius: 50%;
			margin: 0 var(--sp1x);
		}
	}

	.title,
	.highlight {
		margin-bottom: var(--itemsMargin);
	}

	.industries-wrapper {
		display: flex;
		flex-wrap: wrap;
		gap: var(--industriesGap);
		margin-bottom: var(--itemsMargin);
	}

	.banner-image-wrapper {
		margin-bottom: var(--imgMarginB);

		.image-cont {
			--proportion: var(--imageSize);

			img {
				border-radius: var(--borderRadius);
			}
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) and (min-width: ${(props) => props.theme.mediaQuery.desktopSizeL}) {
		--itemsMargin: var(--sp4x);
		--imgMarginB: var(--sp7x);
		--industriesGap: var(--sp2x);
		--borderRadius: var(--sp4x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.desktopSizeM}) {
		--itemsMargin: var(--sp4x);
		--imgMarginB: var(--sp6x);
		--industriesGap: var(--sp2x);
		--borderRadius: var(--sp4x);
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) and (min-width: ${(props) => props.theme.mediaQuery.desktopSizeS}) {
		--itemsMargin: var(--sp4x);
		--imgMarginB: var(--sp5x);
		--industriesGap: var(--sp2x);
		--borderRadius: var(--sp3x);
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.tabletSize}) {
		--itemsMargin: var(--sp4x);
		--imgMarginB: var(--sp5x);
		--industriesGap: var(--sp2x);
		--borderRadius: var(--sp3x);
	}

	/* //! 1024 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.tabletSizeX}) {
		--itemsMargin: var(--sp4x);
		--imgMarginB: var(--sp5x);
		--industriesGap: var(--sp2x);
		--borderRadius: var(--sp3x);
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) and (min-width: ${(props) => props.theme.mediaQuery.tabletSizeS}) {
		--itemsMargin: var(--sp3x);
		--imgMarginB: var(--sp5x);
		--industriesGap: var(--sp1-5x);
		--borderRadius: var(--sp1-5x);
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--itemsMargin: var(--sp3x);
		--imgMarginB: var(--sp4x);
		--industriesGap: var(--sp1x);
		--borderRadius: var(--sp1-5x);
	}
`;

export default MainSectionStyle;
